import { AdornedInput, token, mediaBreakpointMixin, Form, FormField, Box, Label, IconSearch, Adornment, Input } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';

var StyledAdornment = /*#__PURE__*/styled(Adornment).withConfig({
  componentId: "sc-s4kqru-0"
})(["background-color:transparent;border:none;"]);
var StyledInput = /*#__PURE__*/styled(Input).withConfig({
  componentId: "sc-s4kqru-1"
})(["background-color:transparent;border:none;&&&&:active,&&&&:focus{background-color:transparent;}&&&&:focus ~ ", ",&&&:active ~ ", "{background-color:transparent;}"], StyledAdornment, StyledAdornment);
var StyledAdornedInput = /*#__PURE__*/styled(AdornedInput).withConfig({
  componentId: "sc-s4kqru-2"
})(["height:40px;width:300px;border-radius:", ";border:1px solid ", ";&:hover{border-color:", ";}&&:focus-within{border-radius:", ";}@media ", "{&:focus-within{position:absolute;top:10px;left:0;width:100%;background-color:", ";}&:not(:focus-within){width:42px;overflow:hidden;", "{transform:translateX(-3px);}}}"], token('radii.pill'), token('colors.borderLight'), token('colors.borderDark'), token('radii.pill'), mediaBreakpointMixin('md_lte'), token('colors.white'), StyledAdornment);
var SearchBox = function SearchBox(_ref) {
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Search Blog' : _ref$placeholder,
    _ref$actionPrefix = _ref.actionPrefix,
    actionPrefix = _ref$actionPrefix === void 0 ? '/search' : _ref$actionPrefix;
  return /*#__PURE__*/React.createElement(Form, {
    action: "" + actionPrefix,
    method: "get"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Box, {
      as: Label,
      sx: {
        '&&&&': {
          display: 'none'
        }
      }
    }, "Search"),
    control: /*#__PURE__*/React.createElement(StyledAdornedInput, {
      title: "Search",
      input: /*#__PURE__*/React.createElement(StyledInput, {
        name: "s",
        placeholder: placeholder
      }),
      leftAdornment: /*#__PURE__*/React.createElement(StyledAdornment, null, /*#__PURE__*/React.createElement(IconSearch, {
        size: "xs"
      }))
    })
  }));
};
var SearchBox$1 = SearchBox;

export { SearchBox$1 as default };
